import script from "./RankSkillsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RankSkillsModal.vue?vue&type=script&setup=true&lang=js"

import "./RankSkillsModal.vue?vue&type=style&index=0&id=7f9a38fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f9a38fb"]])

export default __exports__